<template>
  <div>
    <div class="section__child">
      <div
        v-if="isLoadingPaymentSdk"
        class="loader"
      />

      <div v-else>
        <card-information-square
          v-if="paymentGateway.providers['Square']"
          ref="cardInformation"
          :payment-gateway="paymentGateway"
          :skip-required-validation="skipRequiredValidation"
          @error="cardInformationError"
          @interacted="cardInformationInteraction"
          @success="cardInformationSuccess"
        />

        <card-information-stripe
          v-else-if="paymentGateway.providers['Stripe']"
          ref="cardInformation"
          :payment-gateway="paymentGateway"
          :skip-required-validation="skipRequiredValidation"
          @error="cardInformationError"
          @interacted="cardInformationInteraction"
          @success="cardInformationSuccess"
        />

        <card-information-standard
          v-else
          ref="cardInformation"
          :is-checkout-flow="isCheckoutFlow"
          :require-billing-address="requireBillingAddress"
          :tds-provider="tdsProvider"
          :skip-required-validation="skipRequiredValidation"
          @error="cardInformationError"
          @interacted="cardInformationInteraction"
          @success="cardInformationSuccess"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import CardInformationSquare from './card-information-square.vue';
  import CardInformationStandard from './card-information-standard.vue';
  import CardInformationStripe from './card-information-stripe.vue';

  import loadPaymentSDK from '@/helpers/load-payment-sdk';

  export default {
    name: 'CardInformation',

    components: {
      CardInformationSquare,
      CardInformationStandard,
      CardInformationStripe
    },

    inject: {
      $validator: {
        from: '$validator'
      }
    },

    props: {
      isCheckoutFlow: {
        type: Boolean,
        default: true
      },

      paymentGateway: {
        type: Object,
        required: true
      },

      tdsProvider: {
        type: String,
        default: ''
      },

      requireBillingAddress: {
        type: Boolean,
        default: false
      },

      skipRequiredValidation: {
        type: Boolean,
        default: false
      }
    },

    data() {
      return {
        isLoadingPaymentSdk: false
      };
    },

    created() {
      this.createdHandler();
    },

    methods: {
      createdHandler() {
        if (!this.isCheckoutFlow) {
          this.getPaymentSdk();
        }
      },

      async getPaymentSdk() {
        this.isLoadingPaymentSdk = true;
        await loadPaymentSDK(this.paymentGateway);
        this.isLoadingPaymentSdk = false;
      },

      cardInformationSuccess(data) {
        this.$emit('success', data);
      },

      cardInformationInteraction() {
        this.$emit('interacted');
      },

      cardInformationError(error) {
        this.$emit('error', error);
      },

      submit() {
        this.$refs.cardInformation.submit();
      }
    }
  };
 </script>

